import { render, staticRenderFns } from "./indicator-heading.vue?vue&type=template&id=64289926&scoped=true&"
import script from "./indicator-heading.vue?vue&type=script&lang=js&"
export * from "./indicator-heading.vue?vue&type=script&lang=js&"
import style0 from "./indicator-heading.vue?vue&type=style&index=0&id=64289926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64289926",
  null
  
)

export default component.exports